import React, { useState } from 'react';
import { fetchSsoLinks } from './adminLabApi';

const SsoLinkTool = () => {
    const [customerId, setCustomerId] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [v1Link, setV1Link] = useState('');
    const [v2Link, setV2Link] = useState('');

    const generate = async () => {
        setBusy(true);
        setError('');
        setV1Link('');
        setV2Link('');

        const result = await fetchSsoLinks(customerId);
        setBusy(false);

        if (!result.ok) {
            setError(result.error);
            return;
        }

        setV1Link(result.v1Link);
        setV2Link(result.v2Link);
    };

    const copy = async (value) => {
        if (!value || !navigator.clipboard) return;
        try {
            await navigator.clipboard.writeText(value);
        } catch {
            /* ignore */
        }
    };

    return (
        <div className="dv2-adminlab__tool">
            <label className="dv2-adminlab__field">
                <span>Customer # (Exigo)</span>
                <input
                    className="dv2-adminlab__input"
                    inputMode="numeric"
                    placeholder="e.g. 3172"
                    value={customerId}
                    onChange={(e) => setCustomerId(e.target.value)}
                />
            </label>
            <button
                type="button"
                className="dv2-adminlab__btn"
                disabled={busy || !customerId.trim()}
                onClick={generate}
            >
                {busy ? 'Generating…' : 'Generate SSO links'}
            </button>

            {error ? (
                <p className="dv2-adminlab__error" role="alert">
                    {error}
                </p>
            ) : null}

            {v1Link ? (
                <div className="dv2-adminlab__linkbox">
                    <div className="dv2-adminlab__linkrow">
                        <span className="dv2-adminlab__linklabel">V1</span>
                        <a
                            className="dv2-adminlab__link"
                            href={v1Link}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Open V1 session
                        </a>
                        <button
                            type="button"
                            className="dv2-adminlab__ghostbtn"
                            onClick={() => copy(v1Link)}
                        >
                            Copy
                        </button>
                    </div>
                    <textarea
                        className="dv2-adminlab__textarea"
                        readOnly
                        value={v1Link}
                        rows={2}
                    />
                </div>
            ) : null}

            {v2Link ? (
                <div className="dv2-adminlab__linkbox">
                    <div className="dv2-adminlab__linkrow">
                        <span className="dv2-adminlab__linklabel">V2</span>
                        <a
                            className="dv2-adminlab__link"
                            href={v2Link}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Open V2 session
                        </a>
                        <button
                            type="button"
                            className="dv2-adminlab__ghostbtn"
                            onClick={() => copy(v2Link)}
                        >
                            Copy
                        </button>
                    </div>
                    <textarea
                        className="dv2-adminlab__textarea"
                        readOnly
                        value={v2Link}
                        rows={2}
                    />
                    <p className="dv2-adminlab__hint">
                        V2 links add <code>?portalV2=1</code> so the session
                        opens Portal V2 routes after sign-in.
                    </p>
                </div>
            ) : null}
        </div>
    );
};

export default SsoLinkTool;
